export default __webpack_public_path__ + "static/media/andres4.a3276e61.jpg";